/**
 * @flow
 * @relayHash 44d92f48c94b8d4780434af792c8b876
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LowStockWidgetQueryVariables = {||};
export type LowStockWidgetQueryResponse = {|
  +lowStockItems: $ReadOnlyArray<{|
    +item: {|
      +id: string
    |}
  |}>
|};
export type LowStockWidgetQuery = {|
  variables: LowStockWidgetQueryVariables,
  response: LowStockWidgetQueryResponse,
|};
*/


/*
query LowStockWidgetQuery {
  lowStockItems {
    item {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "lowStockItems",
    "storageKey": null,
    "args": null,
    "concreteType": "LowStockItem",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "item",
        "storageKey": null,
        "args": null,
        "concreteType": "Item",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LowStockWidgetQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "LowStockWidgetQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "LowStockWidgetQuery",
    "id": null,
    "text": "query LowStockWidgetQuery {\n  lowStockItems {\n    item {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0915425e01410422cec232501c802178';
module.exports = node;
